import api from './api'
import store from '@/store'

// дефолтное тело axios для запросов в сервис чата
const chatApi = (config, headers) =>
  api({
    ...config,
    baseURL: process.env.CHAT_SERVER,
    headers: {
      ...headers,
      Authorization: `Bearer ${store && store.getters.provider.chat.token}`,
    },
  })

export const authorization = data =>
  api({
    method: 'post',
    baseURL: process.env.CHAT_SERVER,
    url: `/auth/login`,
    data,
  })

export const getProfile = () =>
  chatApi({
    method: 'get',
    url: `/profile`,
  })

export const getChatList = (chatPage = 1) =>
  chatApi({
    method: 'get',
    url: `/chat?page=${chatPage}`,
  })

export const getUsers = url =>
  chatApi({
    method: 'get',
    url,
  })

export const searchUsers = searchStr =>
  chatApi({
    method: 'get',
    url: `/users?search=${searchStr}`,
  })

export const getMessagesChats = url =>
  chatApi({
    method: 'get',
    url,
  })

export const getChatsMembers = id =>
  chatApi({
    method: 'get',
    url: `/chat/${id}/users`,
  })

export const createChat = ({ id, formData }) =>
  chatApi({
    method: 'post',
    url: `/chat`,
    data: formData,
  })

export const getChatData = id =>
  chatApi({
    method: 'get',
    url: `/chat/${id}`,
  })

export const getAttachedFilesIds = formData =>
  chatApi({
    method: 'post',
    url: `/mediafiles`,
    data: formData,
  })

export const saveChat = ({ id, formData }) =>
  chatApi({
    method: 'post',
    url: `/chat/${id}`,
    data: formData,
  })

export const setChatMessage = ({ id, data }) =>
  chatApi({
    method: 'post',
    url: `/chat/${id}/messages`,
    data,
  })

export const deleteMessage = ({ chatId, messageId }) =>
  chatApi({
    method: 'delete',
    url: `/chat/${chatId}/messages/${messageId}`,
  })

export const updateMessage = ({ chatId, messageId, data }) =>
  chatApi({
    method: 'put',
    url: `/chat/${chatId}/messages/${messageId}`,
    data,
  })

export const addMemberToChat = ({ chatId, formData }) =>
  chatApi({
    method: 'post',
    url: `/chat/${chatId}/users`,
    data: formData,
  })

export const removeMemberFromChat = ({ chatId, userId }) =>
  chatApi({
    method: 'delete',
    url: `/chat/${chatId}/users/${userId}`,
  })

export const pinAndUnpinChat = chatId =>
  chatApi({
    method: 'post',
    url: `/chat/pin/${chatId}`,
  })

export const searchMessages = searchParams =>
  chatApi({
    method: 'get',
    url: '/chat/messages',
    params: searchParams,
  })

export const setReadChatStatus = chatId =>
  chatApi({
    method: 'post',
    url: `/chat/read/${chatId}`,
  })
